import { html, ifDefined } from "../../../"
import { SYSControlBase } from "./syscontrolbase"
import { isMobile } from "../../../global/globals"
import { _setFieldFocus } from "../helper"
import { _focusOutHelper } from "./helpers"

export class SYSTime extends SYSControlBase {
  async init() {
    if (isMobile()) {
      this.addEventListener("input", this.handleChange)
    } else {
      this.addEventListener("change", this.handleChange)
    }
    await super.init()
  }

  handleChange = (e: Event) => {
    e.stopPropagation()
    e.preventDefault()
    this.actions.ovl.form._ChangeField({
      fieldKey: this.field.fieldKey,
      formState: this.formState,
      value: this.inputElement.value,
      watched: true,
      noRetrigger: true,
    })
  }
  async getUI() {
    let visible = super.InitControl()
    if (visible === false) {
      return undefined
    }

    let field = this.field
    let readonly = this.getReadOnly()
    type TimeBoxType = "text" | "time"
    let type: TimeBoxType = "text"
    if (isMobile()) {
      type = "time"
    }
    return html`
      <div
        class="${this.getContainerClass(
          "time",

          this.customInfo.customRowClassContainerName
        )}"
      >
        <ovl-controllabel .props=${() => this.field}> </ovl-controllabel>

        <input
          tabindex=${ifDefined(!this.focusable ? "-1" : undefined)}
          @focusout=${(e) => _focusOutHelper(e, this.field)}
          @focus=${() => _setFieldFocus(this.field, true)}
          autocomplete="off"
          spellcheck="false"
          class=${`ovl-formcontrol-value fd-input  __inpfocbox ${this.getInputClass(
            "time",

            this.customInfo.customRowClassName
          )}`}
          type=${type}
          id=${field.id}
          value=${field.value}
          ?readonly=${readonly}
        />
      </div>
      <ovl-controlcustomhint .props=${() => this.field}>
      </ovl-controlcustomhint>
      <ovl-controlvalidationhint .props=${() => this.field}>
      </ovl-controlvalidationhint>
    `
  }
  async afterRender() {
    this.inputElement = document.getElementById(this.field.id)
    if (this.inputElement) {
      this.inputElement.value = this.field.value
    }
    await super.afterRender()
  }
  async disconnectedCallback() {
    if (isMobile()) {
      this.removeEventListener("input", this.handleChange)
    } else {
      this.removeEventListener("change", this.handleChange)
    }
    await super.disconnectedCallback()
  }
}
